import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SEOIntroSection from './components/SEOIntroSection';
import FeatureSection from './components/FeatureSection';
import CategoryGridSection from './components/CategoryGridSection';
import ComparisonSection from './components/ComparisonSection';
import CompetitorHubsSection from './components/CompetitorHubsSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://hipobuyspread.skin';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <SEOIntroSection />
          <FeatureSection />
          <CategoryGridSection />
          <ComparisonSection />
          <CompetitorHubsSection />
          <FAQSection />
          <FinalCTASection />
        </article>
      </main>
      <Footer />

      {/* SEO Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Hipobuy Spreadsheet Guide',
            url: SITE_URL,
            description: 'The most comprehensive English information hub about Hipobuy Spreadsheet. Helping shoppers research, compare and discover products faster with organized spreadsheet resources.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Hipobuy Spreadsheet Guide',
            url: SITE_URL,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
            description: 'The most comprehensive English information hub about Hipobuy Spreadsheet.',
            sameAs: [],
          }),
        }}
      />
    </>
  );
}